import { FilePreview } from "@/components/ui/file-preview";
import { StatusText } from "@common/components/StatusText";
import { DataTableColumnHeader } from "@common/components/Table/DataTableColumnHeader";
import { formatDollars, formatDate } from "@common/components/utils";
import { StipendExpense, StipendExpenseStatus } from "@common/utils/graphql";
import { Body } from "@hypercard/web-components";
import { ColumnDef } from "@tanstack/react-table";
import { PaymentMethod } from "./PaymentMethod";

export const stipendsEmployeeColumns: ColumnDef<StipendExpense>[] = [
  {
    accessorKey: "merchantName",
    header: ({ column }) => {
      return <DataTableColumnHeader column={column} title="Merchant" />;
    },
  },
  {
    accessorKey: "transactionDate",
    header: ({ column }) => {
      return <DataTableColumnHeader column={column} title="Date" />;
    },
    cell: ({ row }) => <div>{formatDate(row.original.transactionDate)}</div>,
  },
  {
    accessorKey: "amount",
    header: ({ column }) => {
      return <DataTableColumnHeader column={column} title="Amount" />;
    },
    cell: ({ row }) => <div>{formatDollars(row.original.amount)}</div>,
  },
  {
    accessorKey: "notes",
    header: ({ column }) => {
      return <DataTableColumnHeader column={column} title="Memo" />;
    },
    cell: ({ row }) => <div>{row.original.notes || "No notes"}</div>,
  },
  {
    accessorKey: "receipt",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Receipt" />
    ),
    cell: ({ row }) => {
      return <FilePreview url={row.original.receiptFileUrl} />;
    },
  },
  {
    accessorKey: "status",
    header: ({ column }) => (
      <DataTableColumnHeader
        className="justify-end"
        column={column}
        title="Status"
      />
    ),
    cell: ({ row }) => {
      const isPending = row.original.status === StipendExpenseStatus.Pending;
      const designaterReviewer =
        row.original.designatedApprover?.displayName ?? "Any Admin";
      return (
        <div className="text-right">
          <StatusText {...row.original} />
          <PaymentMethod stipendExpense={row.original} />
          {isPending && (
            <Body size="sm" weight="medium" className="text-muted-foreground">
              {`Reviewer: ${designaterReviewer}`}
            </Body>
          )}
        </div>
      );
    },
  },
];
